import React, { Component } from 'react';
import { Alert, Grid } from 'react-bootstrap';
import { Link } from 'react-router';

class Alerts extends Component {
  render() {
    const { alerts } = this.props;
    return alerts && alerts.length ? (
      <Grid className="bn-alerts">
        {alerts.map(({ headline, link, text, style, multiline }, idx) =>
          headline ? (
            <Alert key={idx} bsStyle={style}>
              <strong>
                {link ? <Link {...link}>{headline}</Link> : headline}
              </strong>
              {multiline ? <br /> : ' '}
              {text}
            </Alert>
          ) : (
            <Alert key={idx} bsStyle={style}>
              {link ? <Link {...link}>{text}</Link> : text}
            </Alert>
          )
        )}
      </Grid>
    ) : null;
  }
}
export default Alerts;
